import { useSuspenseQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';

import { getCommonProcessYn } from '../api';

export const useCheckCommonProcessYn = () => {
  const [searchParams] = useSearchParams();
  const hspId = searchParams.get('hspId');

  const {
    data: { data },
  } = useSuspenseQuery({
    queryKey: ['commonProcess'],
    queryFn: () => getCommonProcessYn({ hspId }),
  });
  const { commonProcessYn, headerList } = data;
  sessionStorage.setItem('commonProcess', JSON.stringify({ commonProcessYn, headerList }));
};

export const useGetCcrcTpDetail = ({ ccrcGuidId, hspId, hspCd }) => {
  const res = useSuspenseQuery({
    queryKey: ['getCcrcTpDetail', ccrcGuidId, hspId, hspCd],
    queryFn: () =>
      axios.get(`${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/ccrcpopup/${ccrcGuidId}/${hspCd}/${hspId}`),
    gcTime: 0,
  });
  return res;
};

